import {immerable} from "immer"

class PuzzleMatrixCell {
    [immerable] = true

    /**
     * @typedef {Object} PuzzleMatrixCellArgs
     * @property {_Coordinates} imgSlice
     * @property {boolean} [selected]
     * @property {boolean} [locked]
     * 
     * @param {PuzzleMatrixCellArgs} args
     */
    constructor(args) {
        this.imgSlice = args.imgSlice;
        this.selected = args.selected !== undefined ? args.selected : false;
        this.locked = args.locked !== undefined ? args.locked : false;
    }

    /**
     * 
     * @param {CoordinatesObj} coordinates 
     */
    areCoordinatesMatching(coordinates) {
        return this.imgSlice.equals(coordinates);
    }
}

export default PuzzleMatrixCell;
